export type TAttorneysListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
};

export type TAttorneysTransactionsListParams = TAttorneysListParams & {
  from: string;
  to: string;
};

export const attorneysKeys = {
  all: [{ module: 'attorneys' }] as const,
  accessLists: () => [{ ...attorneysKeys.all[0], scope: 'accessList' }] as const,
  accessList: (params: TAttorneysListParams) => [{ ...attorneysKeys.accessLists()[0], params }] as const,
  passcodeLists: () => [{ ...attorneysKeys.all[0], scope: 'passcodeList' }] as const,
  passcodeList: (params: TAttorneysListParams) => [{ ...attorneysKeys.passcodeLists()[0], params }] as const,
  userLists: () => [{ ...attorneysKeys.all[0], scope: 'userList' }] as const,
  userList: (params: TAttorneysListParams) => [{ ...attorneysKeys.userLists()[0], params }] as const,
  transactionLists: () => [{ ...attorneysKeys.all[0], scope: 'transactionList' }] as const,
  transactionListsByOrg: (organizationId: string) =>
    [{ ...attorneysKeys.transactionLists()[0], organizationId }] as const,
  transactionList: (organizationId: string, params: TAttorneysTransactionsListParams) =>
    [{ ...attorneysKeys.transactionListsByOrg(organizationId)[0], params }] as const,
};
